import React, { useState } from "react";
import { Tab, Nav, Collapse, Card } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import "./cmistyle.css";
import icon from "../../assets/used-images/tab-icon.png";

const Plan = () => {
  const [activeKey, setActiveKey] = useState("first");
  const [openCard, setOpenCard] = useState(null);

  const toggleCard = (cardIndex) => {
    setOpenCard(openCard === cardIndex ? null : cardIndex);
  };

  // Content for first tab
  const firstTabContent = [
    {
      icon: icon,
      title: "  التفكير الاستراتيجي واتخاذ القرار",
      description: (
        <ul>
          <li>سيتعلم المشاركون استخدام الرؤى المستندة إلى البيانات لاتخاذ قرارات استراتيجية.</li>
          <li>موازنة الأهداف التنظيمية مع استراتيجيات قابلة للتنفيذ.</li>
          <li>تحسين تخصيص الموارد لتحقيق النمو المستدام.</li>
        </ul>
      ),
    },
    {
      icon: icon,
      title: "  إدارة تجربة العملاء",
      description: (
        <ul>
          <li>تركز هذه الكفاءة على تصميم وتنفيذ استراتيجيات لتعزيز رضا العملاء وولائهم</li>
          <li>وتعزيز ثقافة تركز على العملاء داخل المنظمة.
          </li>
        </ul>
      ),
    },
    {
      icon: icon,
      title: "إدارة التغيير",
      description: (
        <ul>
          <li>سيكتسب المشاركون الخبرة في تخطيط وتنفيذ والحفاظ على مبادرات التغيير
          </li>
          <li>وإدارة المقاومة
          </li>
          <li>وقيادة التحولات التنظيمية بسلاسة.
          </li>
        </ul>
      ),
    },
    {
        icon: icon,
        title: " الابتكار وحل المشكلات الإبداعي ",
        description: (
          <ul>
            <li>يشجع البرنامج على ثقافة الابتكار، مما يساعد المشاركين على تطوير منتجات وخدمات وعمليات جديدة
            </li>
            <li>تحسين مهاراتهم في حل المشكلات الإبداعية والتفكير الاستراتيجي
            </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "  الفطنة المالية ",
        description: (
          <ul>
           <li>سيصبح المشاركون ماهرين في وضع الميزانيات والتنبؤ والتخطيط المالي</li>
           <li>واتخاذ قرارات مالية سليمة لضمان الاستقرار المالي للمنظمة.
           </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "  إدارة علاقات الأطراف المعنية ",
        description: (
          <ul>
          <li>تتضمن هذه الكفاءة تحديد أولويات العلاقات مع الأطراف المعنية</li>
          <li>والتواصل الفعال
          </li>
          <li>وبناء الثقة لتعزيز الشراكات التعاونية
          </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "   القيادة والتدريب    ",
        description: (
          <ul>
          <li>سيتعلم المشاركون تقديم برامج تدريب وإرشاد فعالة
          </li>
          <li> تطوير قدرات الفريق

          </li>
          <li>  تعزيز ثقافة التحسين المستمر والأداء العالي
  
          </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "    الممارسة التأملية والتطوير الشخصي     ",
        description: (
          <ul>
          <li>يؤكد البرنامج على الممارسة التأملية لتقييم وتحسين الأداء

          </li>
          <li>وتطوير الوعي الذاتي
          </li>
          <li>تنفيذ خطط التطوير الشخصي لتحقيق النمو المستمر
          </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "إدارة المشاريع",
        description: (
          <ul>
          <li>سيكتسب المشاركون الخبرة في تخطيط وإدارة المشاريع الإدارية


          </li>
       <li>ستخدام منهجيات البحث لجمع وتحليل البيانات
       </li>
          <li>تقديم توصيات قابلة للتنفيذ.
          </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "المساواة والتنوع والشمول (EDI) ",
        description: (
          <ul>
<li>تركز هذه الكفاءة على تطوير وتنفيذ سياسات المساواة والتنوع والشمول
</li>
       <li>وتعزيز ثقافة شاملة
       </li>
       <li>ضمان الامتثال للتشريعات والمعايير الأخلاقية في مجال المساواة والتنوع والشمول
       </li>
          </ul>
        ),
      },
  ];

  // Content for second tab
  const secondTabContent = [
    {
        icon: icon,
        title: "  الجدارات الاستراتيجية والتحليلية",
        description: (
          <ul>
         <li>تحليل البيانات وتفسيرها</li>
         <li>التخطيط الاستراتيجي والتنفيذ
         </li>
         <li>إدارة المالية
         </li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "  جدارات القيادة والإدارة",
        description: (
            <ul>
            <li>إدارة التغيير</li>
            <li>إدارة الابتكار</li>
            <li>إدارة المشاريع</li>
            <li>التدريب والإرشاد</li>
          </ul>
        ),
      },
      {
        icon: icon,
        title: "  الجدارات الشخصية والبينية",
        description: (
            <ul>
            <li>إدارة تجربة العملاء</li>
            <li>إدارة علاقات الأطراف المعنية</li>
            <li>المساواة والتنوع والشمول</li>
          </ul>
        ),
      },
      {
          icon: icon,
          title: "   جدارات التطوير الشخصي ",
          description: (
            <ul>
            <li>الممارسة التأملية
            </li>
            <li>النمو الشخصي والوعي الذاتي
            </li>
            </ul>
          ),
        },
       
  ];

  return (
    <section className="plan-section">
      <div className="container ">
        <h2 className="services-header after:w-20 after:-bottom-2 text-center m-auto">
          إطار الجدارات
        </h2>
        <Tab.Container activeKey={activeKey} onSelect={(k) => { setActiveKey(k); setOpenCard(null); }}>
          <Nav variant="tabs" className="mb-5 mt-5 justify-content-center">
            <Nav.Item>
              <Nav.Link eventKey="first" className="tab-link">
                الجدارات التفصيلية
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second" className="tab-link">
                الجدارات الاستراتيجية والتحليلية
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="first">
              <div className="cards-container">
                {firstTabContent.map((card, index) => (
                  <div key={index} className="mb-3 Planning-card">
                    <Card.Body>
                      <div
                        className="card-header"
                        onClick={() => toggleCard(index)}
                      >
                        <div className="card-title">
                        <p> <img src={card.icon} alt={card.icon}/> {card.title}</p>
                          <FaChevronDown
                            style={{
                              transform: openCard === index ? "rotate(180deg)" : "",
                              transition: "transform 0.3s",
                            }}
                          />
                        </div>
                      </div>
                      <Collapse in={openCard === index}>
                      <div className="card-description">
    {typeof card.description === "string" ? (
      <p>{card.description}</p>
    ) : (
      card.description
    )}
  </div>
                      </Collapse>
                    </Card.Body>
                  </div>
                ))}
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey="second">
              <div className="cards-container">
                {secondTabContent.map((card, index) => (
                   <div key={index} className="mb-3 Planning-card">
                   <Card.Body>
                     <div
                       className="card-header"
                       onClick={() => toggleCard(index)}
                     >
                       <div className="card-title">
                       <p> <img src={card.icon} alt={card.icon}/> {card.title}</p>
                         <FaChevronDown
                           style={{
                             transform: openCard === index ? "rotate(180deg)" : "",
                             transition: "transform 0.3s",
                           }}
                         />
                       </div>
                     </div>
                     <Collapse in={openCard === index}>
                     <div className="card-description">
   {typeof card.description === "string" ? (
     <p>{card.description}</p>
   ) : (
     card.description
   )}
 </div>
                     </Collapse>
                   </Card.Body>
                 </div>
                ))}
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Plan;
